import { Chip } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../../shared/components/variables';

export const PriorityChip = styled(Chip)`
  height: 1.6875rem;
  border-radius: 0.25rem;

  &.urgent {
    background-color: ${colorPalette.red500};
    color: ${colorPalette.white};
    border: 1px solid ${colorPalette.red500};
    :hover {
      background-color: ${colorPalette.red550};
    }
  }
  &.high {
    background-color: ${colorPalette.red975};
    border: 1px solid ${colorTokens.error.outlineBorder};
  }
  &.medium {
    background-color: ${colorPalette.yellow950};
    border: 1px solid ${colorPalette.yellow300};
  }
  &.low {
    background-color: ${colorPalette.white};
    border: 1px solid ${colorPalette.neutral550};
  }
`;
